import { render, staticRenderFns } from "./OurKitsItems.vue?vue&type=template&id=4f6a5cc3&scoped=true&"
import script from "./OurKitsItems.vue?vue&type=script&lang=js&"
export * from "./OurKitsItems.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f6a5cc3",
  null
  
)

export default component.exports